import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: 20000,
      color: "#EAF0F7",
    },
}));